import React, { useEffect, useState } from 'react';
import CodeMirror, { EditorView } from "@uiw/react-codemirror";
import { PrimaryButton } from "../UI";
import SuccessAlert from '../UI/Alert/SuccessAlert';
import { useUserContext } from '../../contexts/UserContext';
import { permission } from '../../config/permission';
import EditIcon from '../../assets/icons/edit.svg';
import { findPathAndUpdateValue, getObjFromHtml, isValidJsonString, updateObjInHtml } from '../../utils/helper';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const OfferCode = ({ 
    experienceJSON,
    selectedTemplate,
    setOfferJson,
    getFlattenExperienceJSON,
    setFieldValues,
    validationError,
    setValidationError,
    title,
    dynamicFields = {},
    onChange,
}) => {

    const [code, setCode] = useState("");
    const [copySuccess, setCopySuccess] = useState(false);
    const [enableEdit, setEnableEdit] = useState(false);

    const { userData, checkPermission } = useUserContext();
    const { enums, content } = useContentfulContext();

    useEffect(() => {
        if(selectedTemplate.type === enums.templateTypes.json_a_to_html.id) {
            const parsedJsonSchema = JSON.parse(selectedTemplate?.json_schema)
            const temp  = updateObjInHtml(selectedTemplate.html, parsedJsonSchema?.config_obj_key, JSON.stringify(experienceJSON, null, 2))
            setCode(temp)
            setOfferJson && setOfferJson((prev) => ({ ...prev, content: temp }))
        } else {
            if(Object.keys(dynamicFields).length > 0) {
                let temp = {...experienceJSON};
                Object.keys(dynamicFields).forEach((key) => {
                    const res = findPathAndUpdateValue(temp, key, dynamicFields[key]);
                    temp = {...res.updatedObj};
                })
                setCode(JSON.stringify(temp, null, 2))
            } else {
                if (!enableEdit) {
                    setCode(JSON.stringify(experienceJSON, null, 2))
                }
            }
        }
    }, [experienceJSON, enableEdit])

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopySuccess(true);
        }).catch(err => {
            console.error('Error copying text: ', err);
        });
    }

    const handleOnChange = (e) => {
        setCode(e);
        if(selectedTemplate.type === enums.templateTypes.json_a_to_html.id) {
            setOfferJson((prev) => ({ ...prev, content: e }))
        } else {
            const isValidJson = isValidJsonString(e);
            if(!isValidJson) {
                setValidationError(content.EDIT_OFFER_CONTENT.invalid_json);
                return;
            }
            setValidationError("")
            const fieldValues = getFlattenExperienceJSON(JSON.parse(e));
            setFieldValues(fieldValues);
            if (onChange) onChange(e);
        }
    }

    return (
        <div>
            <div className="flex gap-4 items-baseline space-y-2 mb-6">
                <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">{title || content.EDIT_OFFER_CONTENT.offer_code}</h1>
                {checkPermission(permission.EDIT_OFFER_OP_EDIT_OFFER_CODE) && <div>
                    {!enableEdit && (
                        <img
                            alt=''
                            src={EditIcon}
                            className="w-[20px] cursor-pointer"
                            onClick={() => setEnableEdit(true)}
                            title="Edit"
                        />
                    )}
                </div>}
            </div>
            <CodeMirror
                value={code}
                height="400px"
                readOnly={enableEdit ? false : true}
                editable={enableEdit ? true : false}
                lineWrapping={true}
                extensions={[EditorView.lineWrapping]}
                onChange={handleOnChange}
            />
            {validationError && <pre><div className="text-base leading-tight tracking-tight text-red-500 mt-3">{validationError}</div></pre>}
            <div className='flex justify-between items-end mt-6'>
                <PrimaryButton handleClick={() => {
                    copyToClipboard(code);
                }}>{content.EDIT_OFFER_CONTENT.copy_btn}</PrimaryButton>
            </div>
            {copySuccess && <SuccessAlert disappearTime="2000" onDisappear={() => {
                setCopySuccess(false);
            }}>{content.EDIT_OFFER_CONTENT.success.copied}</SuccessAlert>}
        </div>
    )
}

export default OfferCode;